/* Gedeelde constanten voor de Unified Inbox (tabs, tags, kanalen, talen). */
import { Linkedin, Mail, MessageCircle, UserPlus, Send } from "lucide-react";

// Sprint 6 · #20 — badge-stijl per reply-intent
export const INTENT_STYLE = {
    interested: "border-[#22c55e]/40 text-[#22c55e] bg-[#22c55e]/10",
    meeting_request: "border-[#14e0c8]/40 text-[#14e0c8] bg-[#14e0c8]/10",
    question: "border-[#38bdf8]/40 text-[#38bdf8] bg-[#38bdf8]/10",
    not_interested: "border-[var(--jr-error)]/40 text-[var(--jr-error)] bg-[var(--jr-error)]/10",
    out_of_office: "border-white/15 text-[var(--jr-text-3)] bg-white/[0.04]",
    wrong_person: "border-[#f97316]/40 text-[#f97316] bg-[#f97316]/10",
};

export const TABS = [
    { id: "conversations", labelKey: "inbox.tab_conversations" },
    { id: "upcoming", labelKey: "inbox.tab_upcoming" },
    { id: "sent", labelKey: "inbox.tab_sent" },
];

export const TAGS = [
    { id: "to_be_defined", label: "To be defined", cls: "bg-[var(--jr-amber)]/15 text-[var(--jr-amber)] border-[var(--jr-amber)]/30" },
    { id: "interested", label: "Interested", cls: "bg-[#22c55e]/15 text-[#22c55e] border-[#22c55e]/30" },
    { id: "not_interested", label: "Not interested", cls: "bg-[#ef4444]/15 text-[#ef4444] border-[#ef4444]/30" },
    { id: "wrong_person", label: "Wrong person", cls: "bg-[var(--jr-amber)]/15 text-[var(--jr-amber)] border-[var(--jr-amber)]/30" },
    { id: "meeting_booked", label: "Meeting booked", cls: "bg-[var(--jr-info)]/15 text-[var(--jr-info)] border-[var(--jr-info)]/30" },
];
export const tagMeta = (id) => TAGS.find((t) => t.id === id) || TAGS[0];

// Channel registry — colored brand-consistent metadata for every send channel.
// tint = brand color for pill/border · bg / fg = tailwind classes for badge.
export const CHANNELS = {
    linkedin:         { label: "LinkedIn",   short: "LinkedIn",   Icon: Linkedin,      tint: "#0a66c2", bg: "bg-[#0a66c2]/12", fg: "text-[#4d9be6]",         border: "border-[#0a66c2]/40" },
    linkedin_connect: { label: "LinkedIn Connect", short: "Connect", Icon: UserPlus,   tint: "#0a66c2", bg: "bg-[#0a66c2]/12", fg: "text-[#4d9be6]",         border: "border-[#0a66c2]/40" },
    email:            { label: "Email",      short: "Email",      Icon: Mail,          tint: "#e04b26", bg: "bg-[#e04b26]/12", fg: "text-[#f08b6b]",         border: "border-[#e04b26]/40" },
    whatsapp:         { label: "WhatsApp",   short: "WhatsApp",   Icon: MessageCircle, tint: "#25d366", bg: "bg-[#25d366]/12", fg: "text-[#4be085]",         border: "border-[#25d366]/40" },
};
export const channelMeta = (id) => CHANNELS[id] || { label: id || "?", short: "?", Icon: Send, tint: "#7d7d7d", bg: "bg-white/5", fg: "text-[var(--jr-text-3)]", border: "border-white/10" };

// Canonical channels shown ALWAYS in the multiselect filter (even at count=0).
// Order matches user expectation: LinkedIn (DM + Connect grouped visually), Email, WhatsApp.
export const FILTER_CHANNELS = ["linkedin", "linkedin_connect", "email", "whatsapp"];

// Translation flag registry — the button glyph is the actual country flag
// unicode (works everywhere, no icon fetching). Codes match the backend
// /outreach/{id}/translate lang literal.
export const LANGUAGES = [
    { code: "nl", flag: "🇳🇱", label: "Nederlands" },
    { code: "fr", flag: "🇫🇷", label: "Français" },
    { code: "en", flag: "EN", label: "English" },
];

/**
 * substituteVars — replaces {first_name} / {{first_name}} / {company} etc
 * placeholders in a message body with actual values from the prospect.
 * Handles BOTH single and double braces (AI output is inconsistent) and
 * cleans up dangling greetings ("Hi ," → "Hi,") when a value is empty.
 */
export function substituteVars(text, prospect) {
    if (!text) return "";
    const full = (prospect?.name || "").trim();
    const first = full.split(/\s+/)[0] || "";
    const company = (prospect?.company_name || "").trim();
    return text
        .replace(/\{\{?\s*first[_ ]?name\s*\}?\}/gi, first)
        .replace(/\{\{?\s*(?:full[_ ]?name|name|naam)\s*\}?\}/gi, full)
        .replace(/\{\{?\s*(?:company[_ ]?name|company|bedrijf)\s*\}?\}/gi, company)
        .replace(/\b(Hi|Hallo|Hello|Bonjour|Dag|Beste)\s+,/gi, "$1,");
}
